import React from 'react';


const ScrollBlock = ({
    style,
    text,
    animation
}) => {
    return (
        <div style={style}>
            <marquee direction={animation.direction} scrollamount={animation.speed}>{text}</marquee>
        </div>
    )
};

export default ScrollBlock;